module.exports = __webpack_public_path__ + "static/media/photo-1.20b643c2.avif";